import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./SignIn.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { KanchiOMAuthContext } from "../../ContextAPI/KanchiKisok";

export default function KanchiSignIn() {
  const navigate = useNavigate();
  const { login } = useContext(KanchiOMAuthContext);

  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("🧠 Login Attempt Started");
    console.log("📧 Email:", email);
    console.log("🔑 Password length:", password.length);

    try {
      setLoading(true);

      const response = await login(email, password);

      console.log("✅ Login Successful");
      console.log("📦 Login Response:", response);

      // If your context stores token in localStorage, verify:
      const storedToken = localStorage.getItem("token");
      console.log("🔐 Token in localStorage:", !!storedToken);

      console.log("➡️ Navigating to /order-tracker");

      navigate("/order-tracker");

    } catch (error) {
      console.error("❌ Login Failed");

      if (error.response) {
        console.error("📡 Server Response:", error.response.data);
        console.error("📡 Status Code:", error.response.status);
      } else {
        console.error("📡 Error Message:", error.message);
      }

      alert(
        error.response?.data?.detail ||
        error.message ||
        "Login failed. Please try again."
      );
    } finally {
      setLoading(false);
      console.log("🧹 Login Attempt Finished");
    }
  };

  return (
    <div className="temple-auth-container">
      <div className="temple-auth-frame">
        <div className="temple-auth-card">


          <h1 className="temple-logo-text">
            KANCHI CAFE
          </h1>

          <p className="temple-subtitle">
            OPERATIONAL MANAGER PORTAL
          </p>

          <p className="temple-tagline">
            Authorized Access to Sacred Operations
          </p>

          <div className="temple-divider">
            <span>✦</span>
          </div>

          <form className="temple-form" onSubmit={handleSubmit}>

            <label>Manager Email</label>

            <input
              type="email"
              placeholder="Enter your manager email"
              className="temple-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Manager Password</label>

            <div className="temple-password-wrapper">

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your secure password"
                className="temple-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />

              <span
                className="temple-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>

            </div>

            <div className="temple-forgot">
              Forgot Manager Password?
            </div>

            <button
              type="submit"
              className="temple-signin-btn"
              disabled={loading}
            >
              {loading ? "Signing In..." : "ACCESS OPERATIONS"}
            </button>

          </form>

          <div className="temple-footer">
            Operational Control Panel — Kanchi Cafe
          </div>

        </div>
      </div>
    </div>
  );
}